export default __webpack_public_path__ + "static/toorcon-7a5b0760dcde0bf55729eafde27ab674.svg";